import {
  ProductApi,
  RobloxEconomyApiModelsPurchaseDetailResponse,
  V1PurchasesProductsProductIdPostRequest,
} from '@rbx/clients/economy';
import { getBEDEV1ServiceBasePath } from '@modules/utilities/constants/baseUrl';
import { Configuration } from '@rbx/clients';
import {
  AssetV2Api as AssetApi,
  RobloxEconomyApiModelsItemDetailResponse,
  V2AssetsAssetIdDetailsGetRequest,
} from '@rbx/clients/economy/v2';

export enum CurrencyType {
  Robux = 1,
  RMB = 3,
}
class EconomyClient {
  private productApi: ProductApi;

  private assetApi: AssetApi;

  constructor(basePath: string = getBEDEV1ServiceBasePath('economy')) {
    const defaultConfig = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.productApi = new ProductApi(defaultConfig);
    this.assetApi = new AssetApi(defaultConfig);
  }

  postPurchaseAsset(
    request: V1PurchasesProductsProductIdPostRequest,
  ): Promise<RobloxEconomyApiModelsPurchaseDetailResponse> {
    request.purchaseDetail.expectedCurrency =
      process.env.buildTarget === 'luobu' ? CurrencyType.Robux : CurrencyType.RMB;

    return this.productApi.v1PurchasesProductsProductIdPost(request);
  }

  getAssetDetails(
    request: V2AssetsAssetIdDetailsGetRequest,
  ): Promise<RobloxEconomyApiModelsItemDetailResponse> {
    return this.assetApi.v2AssetsAssetIdDetailsGet(request);
  }
}

const economyClient = new EconomyClient();
export default economyClient;
